module.exports = __webpack_public_path__ + "static/media/forelasning.29334b88.jpg";